// Découpage des commandes shell envoyées à WebContainer.
//
// `webContainer.spawn(cmd, args)` n'est PAS un shell : il lance directement le
// binaire avec la liste d'arguments. Un « && » n'y est donc pas un opérateur —
// il était transmis à npm comme un NOM DE PAQUET, suivi de « npm », « install »
// et « -D ». La commande type
//   npm install react react-dom && npm install -D vite …
// échouait donc intégralement (exit code 1), et l'aperçu restait vide le temps
// que le serveur démarre sans ses dépendances. Mesuré en production le
// 25/09/2026.
//
// D'où ce découpage : chaque sous-commande est lancée séparément, dans l'ordre.

/** Découpe une commande sur `&&` et rend les sous-commandes, dans l'ordre. */
export function decouperSurEtEt(commande: string): string[] {
  return commande
    .split(/\s*&&\s*/)
    .map((c) => c.trim())
    .filter(Boolean);
}

/** Sépare une sous-commande en binaire + arguments, pour `spawn`. */
export function enBinaireEtArguments(sousCommande: string): { cmd: string; args: string[] } {
  const parts = sousCommande.split(/\s+/).filter(Boolean);
  return { cmd: parts[0] ?? '', args: parts.slice(1) };
}

/**
 * Noms de paquets d'une commande `npm install`, pour la déduplication.
 * Les jetons de shell et les mots de commande ne sont pas des paquets : sans ce
 * filtre, « && », « npm » et « install » étaient comptés comme des dépendances
 * déjà installées, ce qui faisait sauter des installations réellement requises.
 */
const NON_PAQUETS = new Set(['&&', '||', ';', '|', 'npm', 'install', 'i', 'npx', 'run']);

export function nomsDePaquets(commande: string): string[] {
  if (!commande.startsWith('npm install') && !commande.startsWith('npm i')) return [];
  return commande
    .split(/\s+/)
    .slice(2)
    .filter((p) => !p.startsWith('-'))
    .filter((p) => !NON_PAQUETS.has(p))
    .map((p) => (p.startsWith('@') ? p.split('@').slice(0, 2).join('@') : p.split('@')[0]))
    .filter((p) => p.length > 0);
}
